import logoFull from "@/assets/logo-full-white-transparent.png";

/**
 * Stand-in cover for the /lm/video-ad guide: the real document screenshots aren't
 * ready yet, so this card shows what the guide looks like. To swap it later, pass
 * `cover` (an image URL) to LeadMagnetPage instead of `coverNode` — this file can
 * then be deleted.
 */
const STATS = [
  "500+ bottom-of-funnel video ads made for our clients",
  "150+ video shoots in the past 4 years",
  "$17.3M+ generated for home-service businesses",
];

const VideoAdGuideCover = () => (
  <div className="mx-auto w-full max-w-md overflow-hidden rounded-2xl border border-white/10 bg-white shadow-[0_30px_70px_-20px_rgba(0,0,0,0.8)]">
    <div className="bg-[#03214B] px-6 py-8 md:px-8 md:py-10">
      <img src={logoFull} alt="The Alpha Omega Hub" className="h-7 w-auto" />
      <p className="mt-7 text-[11px] font-bold uppercase tracking-[0.18em] text-[#FFB002] md:text-xs">
        The Alpha Omega Hub · Free Guide
      </p>
      <p className="mt-3 font-display text-2xl font-bold leading-tight text-white md:text-[1.75rem]">
        The Bottom-of-Funnel Ad that Prints Every Time (for Remodelers)
      </p>
    </div>
    <ul className="space-y-2 bg-white p-4 md:p-5">
      {STATS.map((s) => (
        <li key={s} className="rounded-lg bg-[#F4F5F7] px-4 py-3 text-sm font-semibold text-[#03214B]">
          {s}
        </li>
      ))}
    </ul>
  </div>
);

export default VideoAdGuideCover;
